'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from 'next-themes';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { FormProvider, useForm } from 'react-hook-form';
import { Theme, ThemeSwitcher } from '../_navbar/ThemeSwitcher';
import { AuthProvider } from './authentication/AuthProvider';
import { IsClientCtxProvider } from './IsClientContextProvider';
import { LocalizationProvider } from './localization/LocalizationProvider';
const queryClient = new QueryClient();
export default function Providers(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const methods = useForm();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = Object.values(Theme);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      async: false,
      defer: false,
      appendTo: "head"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ThemeSwitcher />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <LocalizationProvider>{t3}<AuthProvider><NuqsAdapter>{children}</NuqsAdapter></AuthProvider></LocalizationProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ReactQueryDevtools initialIsOpen={false} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <IsClientCtxProvider><ThemeProvider attribute="class" defaultTheme="dark" themes={t1}><GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""} scriptProps={t2} language="en" useEnterprise={false} useRecaptchaNet={false}><QueryClientProvider client={queryClient}>{t4}{t5}</QueryClientProvider></GoogleReCaptchaProvider></ThemeProvider></IsClientCtxProvider>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== methods || $[9] !== t6) {
    t7 = <FormProvider {...methods}>{t6}</FormProvider>;
    $[8] = methods;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}